module.exports = {
  "country": "UA",
  "artist": "Gaitana",
  "song": "Be my Guest",
  "year": "2012",
  "place": "15",
  "spotify": "0ePTavqUwNuoldb8r0pBO9"
};